export default __webpack_public_path__ + "static/media/01.4815bd11.jpg";